/* Root */
const Signin = require('./pages/Signin');
const Dashboard = require('./pages/Dashboard');
const Landing = require('./pages/Landing');
const Maps = require('./pages/Maps');

/* Error */
const Error404 = require('./pages/Error');

/* Preference */
const PreferenceProfile = (resolve) => require(['./pages/preference/profile'], resolve);
const PreferencePassword = (resolve) => require(['./pages/preference/password'], resolve);
const PreferenceSite = (resolve) => require(['./pages/preference/site'], resolve);

/* Admin Systems */
/* Masters */
const adsys_masters_company = (resolve) => require(['./pages/adsys/masters/Company'], resolve);
const adsys_masters_car = (resolve) => require(['./pages/adsys/masters/Car'], resolve);
const adsys_masters_color = (resolve) => require(['./pages/adsys/masters/Color'], resolve);
const adsys_masters_cardefect = (resolve) => require(['./pages/adsys/masters/CarDefect'], resolve);
const adsys_masters_monitor = (resolve) => require(['./pages/adsys/masters/Monitor'], resolve);
const adsys_masters_status = (resolve) => require(['./pages/adsys/masters/Status'], resolve);
const adsys_masters_role = (resolve) => require(['./pages/adsys/masters/Role'], resolve);
const adsys_masters_postal = (resolve) => require(['./pages/adsys/masters/Postal'], resolve);
const adsys_masters_payment_categories = (resolve) => require(['./pages/adsys/masters/PaymentCategories'], resolve);
const adsys_masters_menu = (resolve) => require(['./pages/adsys/masters/Menu'], resolve);
const adsys_masters_defect = (resolve) => require(['./pages/adsys/masters/DefectMaster'], resolve);
/* Configs */
const adsys_config_site = (resolve) => require(['./pages/adsys/config/Site'], resolve);
const adsys_config_caritemmaster = (resolve) => require(['./pages/adsys/config/CarItemMaster'], resolve);
const adsys_config_caritem = (resolve) => require(['./pages/adsys/config/CarItem'], resolve);
const adsys_config_assets = (resolve) => require(['./pages/adsys/config/Assets'], resolve);
const adsys_config_carcompany = (resolve) => require(['./pages/adsys/config/CarCompany'], resolve);
const adsys_config_carfile = (resolve) => require(['./pages/adsys/config/CarFile'], resolve);
const adsys_config_employee = (resolve) => require(['./pages/adsys/config/Employee'], resolve);
const adsys_config_finefee = (resolve) => require(['./pages/adsys/config/FineFee'], resolve);
const adsys_config_floors = (resolve) => require(['./pages/adsys/config/Floor'], resolve);
const adsys_config_imei = (resolve) => require(['./pages/adsys/config/Imei'], resolve);
const adsys_config_workshift = (resolve) => require(['./pages/adsys/config/Workshift'], resolve);
const adsys_config_valetfee = (resolve) => require(['./pages/adsys/config/Valetfee'], resolve);
const adsys_config_park_area = (resolve) => require(['./pages/adsys/config/ParkArea'], resolve);
const adsys_config_park_sector = (resolve) => require(['./pages/adsys/config/ParkSector'], resolve);
const adsys_config_park_detail = (resolve) => require(['./pages/adsys/config/ParkDetail'], resolve);
const adsys_config_keyguard = (resolve) => require(['./pages/adsys/config/Keyguard'], resolve);
const adsys_config_keyguard_details = (resolve) => require(['./pages/adsys/config/KeyguardDetails'], resolve);
const adsys_config_keyguard_position = (resolve) => require(['./pages/adsys/config/KeyguardPosition'], resolve);
const adsys_config_imei_detail = (resolve) => require(['./pages/adsys/config/ImeiDetail'], resolve);
const adsys_config_droppoint_floor = (resolve) => require(['./pages/adsys/config/DroppointFloor'], resolve);
const adsys_config_print = (resolve) => require(['./pages/adsys/config/Print'], resolve);
const adsys_config_report_administrative = (resolve) => require(['./pages/adsys/config/ReportAdministrative'], resolve);
const adsys_config_payment_methods = (resolve) => require(['./pages/adsys/config/PaymentMethods'], resolve);

/* Administrative */
const AdministrativeEntry = (resolve) => require(['./pages/administrative/entry'], resolve);
const AdministrativeRequest = (resolve) => require(['./pages/administrative/request'], resolve);
const AdministrativeStatusFind = (resolve) => require(['./pages/administrative/status_find'], resolve);
const AdministrativeStatusCheckIn = (resolve) => require(['./pages/administrative/status_checkin'], resolve);
const AdministrativeStatusCheckOut = (resolve) => require(['./pages/administrative/status_checkout'], resolve);
const AdministrativeStatusAll = (resolve) => require(['./pages/administrative/status_all'], resolve);
const AdministrativeHistory = (resolve) => require(['./pages/administrative/history'], resolve);
const AdministrativeReportsMain = (resolve) => require(['./pages/administrative/reports_main'], resolve);
const AdministrativeReportsDetail = (resolve) => require(['./pages/administrative/reports_detail'], resolve);
const AdministrativeReportsUnclosed = (resolve) => require(['./pages/administrative/reports_unclosed'], resolve);


/* Keyguard */
const KeyguardRequest = (resolve) => require(['./pages/keyguard/request'], resolve);
const KeyguardStatus = (resolve) => require(['./pages/keyguard/status'], resolve);
const KeyguardHistory = (resolve) => require(['./pages/keyguard/history'], resolve);
const KeyguardReports = (resolve) => require(['./pages/keyguard/reports'], resolve);

/* Masters */
const Employee = (resolve) => require(['./pages/masters/Employee'], resolve);
const Flow = (resolve) => require(['./pages/masters/Flow'], resolve);
const Color = (resolve) => require(['./pages/masters/Color'], resolve);
const Company = (resolve) => require(['./pages/masters/Company'], resolve);

/* Configuration */
/* Site */
const Site = (resolve) => require(['./pages/configuration/site/Site'], resolve);
const Floor = (resolve) => require(['./pages/configuration/site/Floor'], resolve);
const Droppoint = (resolve) => require(['./pages/configuration/site/Droppoint'], resolve);
const PrintTemplate = (resolve) => require(['./pages/configuration/site/PrintTemplate'], resolve);
const Disclaimer = (resolve) => require(['./pages/configuration/site/Disclaimer'], resolve);
/* Price */
const Price = (resolve) => require(['./pages/configuration/price/Price'], resolve);
const FineFee = (resolve) => require(['./pages/configuration/price/Finefee'], resolve);
const ParkFee = (resolve) => require(['./pages/configuration/price/Parkfee'], resolve);
/* Keyguards */
const Keyguard = (resolve) => require(['./pages/configuration/keyguard/Keyguard'], resolve);
const DeskList = (resolve) => require(['./pages/configuration/keyguard/DeskList'], resolve);
const DeskPositionList = (resolve) => require(['./pages/configuration/keyguard/DeskPositionList'], resolve);
/* Park */
const Park = (resolve) => require(['./pages/configuration/park/Park'], resolve);
const ParkSector = (resolve) => require(['./pages/configuration/park/ParkSector'], resolve);
const ParkAreaDetail = (resolve) => require(['./pages/configuration/park/ParkAreaDetail'], resolve);
/* Car */
// const BrandList = (resolve) => require(['./pages/configuration/car/BrandList'], resolve);
const CarFile = (resolve) => require(['./pages/configuration/car/CarFile'], resolve);
const CarDefect = (resolve) => require(['./pages/configuration/car/CarDefect'], resolve);
// const CarItem = (resolve) => require(['./pages/configuration/car/CarItem'], resolve);
// const CarItemMaster = (resolve) => require(['./pages/configuration/car/CarItemMaster'], resolve);

/* Reports */
const DailyHeaders = (resolve) => require(['./pages/reports/DailyHeaders'], resolve);
const DailyDetails = (resolve) => require(['./pages/reports/DailyDetails'], resolve);
const FinefeeDetails = (resolve) => require(['./pages/reports/FinefeeDetails'], resolve);
const ParkfeeDetails = (resolve) => require(['./pages/reports/ParkfeeDetails'], resolve);
const ItemDetails = (resolve) => require(['./pages/reports/ItemDetails'], resolve);
const DefectDetails = (resolve) => require(['./pages/reports/DefectDetails'], resolve);

/* Logs */
const SiteTransaction = (resolve) => require(['./pages/logs/SiteTransaction'], resolve);

/* Etc */
const Menu = (resolve) => require(['./pages/etc/Menu'], resolve);
const PostalCode = (resolve) => require(['./pages/etc/PostalCode'], resolve);
const Role = (resolve) => require(['./pages/etc/Role'], resolve);

const main = [
  {
    path: '/',
    name: 'signin',
    component: Signin
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard
  },
  {
    path: '/landing',
    name: 'landing',
    component: Landing
  },
  {
    path: '/maps',
    name: 'maps',
    component: Maps
  }
];

const adsys = [
  {
    path: '/adsys',
    name: 'adsys',
    redirect: '/adsys/masters/company'
  },
  {
    path: '/adsys/masters',
    name: 'adsys:masters',
    redirect: '/adsys/masters/company'
  },
  {
    path: '/adsys/masters/company',
    name: 'adsys:masters:company',
    component: adsys_masters_company
  },
  {
    path: '/adsys/masters/car',
    name: 'adsys:masters:car',
    component: adsys_masters_car
  },
  {
    path: '/adsys/masters/color',
    name: 'adsys:masters:color',
    component: adsys_masters_color
  },
  {
    path: '/adsys/masters/cardefect',
    name: 'adsys:masters:cardefect',
    component: adsys_masters_cardefect
  },
  {
    path: '/adsys/masters/monitor',
    name: 'adsys:masters:monitor',
    component: adsys_masters_monitor
  },
  {
    path: '/adsys/masters/status',
    name: 'adsys:masters:status',
    component: adsys_masters_status
  },
  {
    path: '/adsys/masters/role',
    name: 'adsys:masters:role',
    component: adsys_masters_role
  },
  {
    path: '/adsys/masters/postal',
    name: 'adsys:masters:postal',
    component: adsys_masters_postal
  },
  {
    path: '/adsys/masters/payment_categories',
    name: 'adsys:masters:payment_categories',
    component: adsys_masters_payment_categories
  },
  {
    path: '/adsys/masters/menu',
    name: 'adsys:masters:menu',
    component: adsys_masters_menu
  },
  {
    path: '/adsys/masters/defect_master',
    name: 'adsys:masters:defect_master',
    component: adsys_masters_defect
  },
  {
    path: '/adsys/config',
    name: 'adsys:config',
    redirect: '/adsys/config/site'
  },
  {
    path: '/adsys/config/site',
    name: 'adsys:config:site',
    component: adsys_config_site
  },
  {
    path: '/adsys/config/caritemmaster',
    name: 'adsys:config:caritemmaster',
    component: adsys_config_caritemmaster
  },
  {
    path: '/adsys/config/caritem',
    name: 'adsys:config:caritem',
    component: adsys_config_caritem
  },
  {
    path: '/adsys/config/assets',
    name: 'adsys:config:assets',
    component: adsys_config_assets
  },
  {
    path: '/adsys/config/carcompany',
    name: 'adsys:config:carcompany',
    component: adsys_config_carcompany
  },
  {
    path: '/adsys/config/carfile',
    name: 'adsys:config:carfile',
    component: adsys_config_carfile
  },
  {
    path: '/adsys/config/employee',
    name: 'adsys:config:employee',
    component: adsys_config_employee
  },
  {
    path: '/adsys/config/finefee',
    name: 'adsys:config:finefee',
    component: adsys_config_finefee
  },
  {
    path: '/adsys/config/floor',
    name: 'adsys:config:floor',
    component: adsys_config_floors
  },
  {
    path: '/adsys/config/imei',
    name: 'adsys:config:imei',
    component: adsys_config_imei
  },
  {
    path: '/adsys/config/workshift',
    name: 'adsys:config:workshift',
    component: adsys_config_workshift
  },
  {
    path: '/adsys/config/valetfee',
    name: 'adsys:config:valetfee',
    component: adsys_config_valetfee
  },
  {
    path: '/adsys/config/park_area',
    name: 'adsys:config:park_area',
    component: adsys_config_park_area
  },
  {
    path: '/adsys/config/park_sector',
    name: 'adsys:config:park_sector',
    component: adsys_config_park_sector
  },
  {
    path: '/adsys/config/park_detail',
    name: 'adsys:config:park_detail',
    component: adsys_config_park_detail
  },
  {
    path: '/adsys/config/keyguard',
    name: 'adsys:config:keyguard',
    component: adsys_config_keyguard
  },
  {
    path: '/adsys/config/keyguard_details',
    name: 'adsys:config:keyguard_details',
    component: adsys_config_keyguard_details
  },
  {
    path: '/adsys/config/keyguard_position',
    name: 'adsys:config:keyguard_position',
    component: adsys_config_keyguard_position
  },
  {
    path: '/adsys/config/imei_detail',
    name: 'adsys:config:imei_detail',
    component: adsys_config_imei_detail
  },
  {
    path: '/adsys/config/droppoint_floor',
    name: 'adsys:config:droppoint_floor',
    component: adsys_config_droppoint_floor
  },
  {
    path: '/adsys/config/print',
    name: 'adsys:config:print',
    component: adsys_config_print
  },
  {
    path: '/adsys/config/report_administrative',
    name: 'adsys:config:report_administrative',
    component: adsys_config_report_administrative
  },
  {
    path: '/adsys/config/payment_methods',
    name: 'adsys:config:payment_methods',
    component: adsys_config_payment_methods
  }
];

const administrative = [
  {
    path: '/administrative',
    name: 'administrative',
    redirect: '/administrative/entry'
  },
  {
    path: '/administrative/entry',
    name: 'administrative:entry',
    component: AdministrativeEntry
  },
  {
    path: '/administrative/request',
    name: 'administrative:request',
    component: AdministrativeRequest
  },
  {
    path: '/administrative/status_checkin',
    name: 'administrative:status_checkin',
    component: AdministrativeStatusCheckIn
  },
  {
    path: '/administrative/status_find',
    name: 'administrative:status_find',
    component: AdministrativeStatusFind
  },
  {
    path: '/administrative/status_checkout',
    name: 'administrative:status_checkout',
    component: AdministrativeStatusCheckOut
  },
  {
    path: '/administrative/status_all',
    name: 'administrative:status_all',
    component: AdministrativeStatusAll
  },
  {
    path: '/administrative/history',
    name: 'administrative:history',
    component: AdministrativeHistory
  },
  {
    path: '/administrative/reports_detail',
    name: 'administrative:reports_detail',
    component: AdministrativeReportsDetail
  },
  {
    path: '/administrative/reports_main',
    name: 'administrative:reports_main',
    component: AdministrativeReportsMain
  },
  {
    path: '/administrative/reports_unclosed',
    name: 'administrative:reports_unclosed',
    component: AdministrativeReportsUnclosed
  }
];

const keyguard = [
  {
    path: '/keyguard',
    name: 'keyguard',
    redirect: '/keyguard/request'
  },
  {
    path: '/keyguard/request',
    name: 'keyguard:request',
    component: KeyguardRequest
  },
  {
    path: '/keyguard/status',
    name: 'keyguard:status',
    component: KeyguardStatus
  },
  {
    path: '/keyguard/history',
    name: 'keyguard:history',
    component: KeyguardHistory
  },
  {
    path: '/keyguard/reports',
    name: 'keyguard:reports',
    component: KeyguardReports
  }
];

const preference = [
  {
    path: '/preference',
    name: 'preference',
    redirect: '/preference/profile'
  },
  {
    path: '/preference/profile',
    name: 'preference:profile',
    component: PreferenceProfile
  },
  {
    path: '/preference/password',
    name: 'preference:password',
    component: PreferencePassword
  },
  {
    path: '/preference/site',
    name: 'preference:site',
    component: PreferenceSite
  }
];

const masters = [
  {
    path: '/masters',
    name: 'masters',
    redirect: '/masters/employee'
  },
  {
    path: '/masters/employee',
    name: 'masters:employee',
    component: Employee
  },
  {
    path: '/masters/flow',
    name: 'masters:flow',
    component: Flow
  },
  {
    path: '/masters/color',
    name: 'masters:color',
    component: Color
  },
  {
    path: '/masters/company',
    name: 'masters:company',
    component: Company
  }
];

const configuration = [
  {
    path: '/configuration',
    name: 'configuration',
    redirect: '/configuration/site/site'
  },
  {
    path: '/configuration/site',
    name: 'configuration:site',
    redirect: '/configuration/site/site'
  },
  {
    path: '/configuration/site/site',
    name: 'configuration:site:site',
    component: Site
  },
  {
    path: '/configuration/site/floor',
    name: 'configuration:site:floor',
    component: Floor
  },
  {
    path: '/configuration/site/droppoint',
    name: 'configuration:site:droppoint',
    component: Droppoint
  },
  {
    path: '/configuration/site/printtemplate',
    name: 'configuration:site:printtemplate',
    component: PrintTemplate
  },
  {
    path: '/configuration/site/disclaimer',
    name: 'configuration:site:disclaimer',
    component: Disclaimer
  },
  {
    path: '/configuration/price/price',
    name: 'configuration:price:price',
    component: Price
  },
  {
    path: '/configuration/price/finefee',
    name: 'configuration:price:finefee',
    component: FineFee
  },
  {
    path: '/configuration/price/parkfee',
    name: 'configuration:price:parkfee',
    component: ParkFee
  },
  {
    path: '/configuration/keyguard/keyguard',
    name: 'configuration:keyguard:keyguard',
    component: Keyguard
  },
  {
    path: '/configuration/keyguard/desklist',
    name: 'configuration:keyguard:desklist',
    component: DeskList
  },
  {
    path: '/configuration/keyguard/deskpositionlist',
    name: 'configuration:keyguard:deskpositionlist',
    component: DeskPositionList
  },
  {
    path: '/configuration/park/park',
    name: 'configuration:park:park',
    component: Park
  },
  {
    path: '/configuration/park/parksector',
    name: 'configuration:park:parksector',
    component: ParkSector
  },
  {
    path: '/configuration/park/parkareadetail',
    name: 'configuration:park:parkareadetail',
    component: ParkAreaDetail
  },
  /*{
    path: '/configuration/car/brandlist',
    name: 'configuration:car:brandlist',
    component: BrandList
  },*/
  {
    path: '/configuration/car/carfile',
    name: 'configuration:car:carfile',
    component: CarFile
  },
  {
    path: '/configuration/car/cardefect',
    name: 'configuration:car:cardefect',
    component: CarDefect
  }/*,
  {
    path: '/configuration/car/caritem',
    name: 'configuration:car:caritem',
    component: CarItem
  },
  {
    path: '/configuration/car/caritemmaster',
    name: 'configuration:car:caritemmaster',
    component: CarItemMaster
  } */
];

const reports = [
  {
    path: '/reports',
    name: 'reports',
    redirect: '/reports/DailyHeaders'
  },
  {
    path: '/reports/dailyheaders',
    name: 'reports:dailyheaders',
    component: DailyHeaders
  },
  {
    path: '/reports/dailydetails',
    name: 'reports:dailydetails',
    component: DailyDetails
  },
  {
    path: '/reports/finefeedetails',
    name: 'reports:finefeedetails',
    component: FinefeeDetails
  },
  {
    path: '/reports/parkfeedetails',
    name: 'reports:parkfeedetails',
    component: ParkfeeDetails
  },
  {
    path: '/reports/itemdetails',
    name: 'reports:itemdetails',
    component: ItemDetails
  },
  {
    path: '/reports/defectdetails',
    name: 'reports:defectdetails',
    component: DefectDetails
  }
];

const logs = [
  {
    path: '/logs',
    name: 'logs',
    redirect: '/logs/sitetransaction'
  },
  {
    path: '/logs/sitetransaction',
    name: 'logs:sitetransaction',
    component: SiteTransaction
  }
];

const etc = [
  {
    path: '/etc',
    name: 'etc',
    redirect: '/etc/menu'
  },
  {
    path: '/etc/menu',
    name: 'etc:menu',
    component: Menu
  },
  {
    path: '/etc/postalcode',
    name: 'etc:postalcode',
    component: PostalCode
  },
  {
    path: '/etc/role',
    name: 'etc:role',
    component: Role
  }
];

const error = [
  {
    path: '*',
    name: 'error',
    component: Error404
  }
];

export default [].concat(main, adsys, administrative, keyguard, preference, masters, configuration, reports, logs, etc, error);



// WEBPACK FOOTER //
// ./src/routes.js